import { inject, Injectable } from '@angular/core';
import { CookiesService } from '@rma/generic/ng/util';
import { UuidGenerationService } from '@rma/public/generic/util/uuid-generation';

/**
 * A lot of this is due to the trixel cookie being set as HTTP only
 * It is no longer, but we need to cater for that.
 * Trixel cookies last a year, so we should be able to ignore this after 01/01/2026
 */
@Injectable()
export class DeviceIdentificationService {
  private readonly cookiesService = inject(CookiesService);
  private readonly uuidGenerationService = inject(UuidGenerationService);
  private readonly trixelsCookie = 'DeviceId';
  private readonly fallBackCookie = 'FallbackDeviceId';

  private deviceId?: string;

  public getDeviceId(): string {
    if (this.deviceId) {
      return this.deviceId;
    }
    const cookieId = this.readFromCookie();
    if (cookieId) {
      this.deviceId = cookieId;
      return this.deviceId;
    }

    const uuid = this.uuidGenerationService.generateUuid();

    this.cookiesService.put(this.fallBackCookie, uuid);
    this.deviceId = uuid;

    return this.deviceId;
  }
  private readFromCookie(): string {
    return this.cookiesService.get(this.trixelsCookie) || this.cookiesService.get(this.fallBackCookie);
  }
}
